<template>
  <b-modal
    ref="password-modal"
    no-close-on-backdrop
    hide-footer
    title="เปลี่ยนรหัสผ่าน"
    ok-variant="success"
    ok-title="เปลี่ยนรหัสผ่าน"
    cancel-title="ยกเลิก"
    footer-class="justify-content-between"
    @show="resetModal"
    @hidden="resetModal"
    class="position-relative"
  >
    <form
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >

      <b-form-group
        label="ชื่อผู้ใช้"
      >
        <b-form-input
          v-model="input.username"
          type="text"
          disabled
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="รหัสผ่านใหม่"
        label-for="input-new-password"
      >
        <b-form-input
          id="input-new-password"
          v-model="input.nPassword"
          type="password"
          required
          :state="validPassword"
        ></b-form-input>
        <small class="form-text text-muted">
          <ul class="pl-3">
            <li>ความยาวอย่างน้อย 8 ตัวอักษร <i class="fas fa-check text-success" v-if="pwLength"></i></li>
            <li>อักษรภาษาอังกฤษพิมพ์ใหญ่ อย่างน้อย 1 ตัว <i class="fas fa-check text-success" v-if="pwUppercase"></i></li>
            <li>อักษรภาษาอังกฤษพิมพ์เล็ก อย่างน้อย 1 ตัว <i class="fas fa-check text-success" v-if="pwLowercase"></i></li>
            <li>ตัวเลข อย่างน้อย 1 ตัว <i class="fas fa-check text-success" v-if="pwNumber"></i></li>
            <li>อักษรพิเศษ อย่างน้อย 1 ตัว <i class="fas fa-check text-success" v-if="pwSymbol"></i></li>
          </ul>
        </small>
      </b-form-group>

      <b-form-group
        label="ยืนยันรหัสผ่าน"
        label-for="input-confirm-password"
      >
        <b-form-input
          id="input-confirm-password"
          v-model="input.cPassword"
          type="password"
          required
        ></b-form-input>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3 pt-3">
        <b-button variant="link" size="sm" class="text-secondary mr-3" @click="hideModal">ยกเลิก</b-button>
        <b-button type="submit" variant="primary" size="sm" :disabled="!validPassword || isProcess">{{isProcess ? 'กำลังบันทึก...' : 'บันทึกรหัสผ่าน'}}</b-button>
      </div>
    </form>

    <loading
      :active="isProcess"
      :can-cancel="false"
      :is-full-page="false"
      background-color="#EBEDEF"
      :height="30"
      :width="30"
      color="#007bff"
    />
  </b-modal>
</template>
<script>
import ManageAccountService from "@/services/ManageAccountService"
import Swal from 'sweetalert2'
import cAlert from '@/helpers/alert'
import { passwordStrength } from 'check-password-strength'

export default {
  name: 'ChangePasswordModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {
        _id: null,
        username: null,
        nPassword: null,
        cPassword: null
      }
    }
  },
  data() {
    return {
      isProcess: false,
      input: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    pwStrength() {
      return passwordStrength(this.input.nPassword)
    },
    pwLength() {
      return this.pwStrength.length >= 8
    },
    pwLowercase() {
      return this.pwStrength.contains.includes('lowercase')
    },
    pwUppercase() {
      return this.pwStrength.contains.includes('uppercase')
    },
    pwNumber() {
      return this.pwStrength.contains.includes('number')
    },
    pwSymbol() {
      return this.pwStrength.contains.includes('symbol')
    },
    validPassword() {
      if(!this.input.nPassword)
        return null

      return this.pwLength && this.pwLowercase && this.pwUppercase && this.pwNumber && this.pwSymbol
    }
  },
  watch: {
    isShow() {
      if(this.isShow){
        this.showModal()
      }else{
        this.hideModal()
      }
    },
    data() {
      this.input = JSON.parse(JSON.stringify(this.data))
    }
  },
  methods: {
    resetModal() {
      this.isProcess = false
      this.input = {
        _id: null,
        username: null,
        nPassword: null,
        cPassword: null
      }
    },
    showModal() {
      this.$refs['password-modal'].show()
    },
    hideModal() {
      this.$refs['password-modal'].hide()
    },
    handleSubmit() {

      if(!this.validPassword) {
        Swal.fire({
          text: 'รูปแบบรหัสผ่านไม่ถูกต้อง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
        return
      }else
      if(this.input.nPassword !== this.input.cPassword) {
        Swal.fire({
          text: 'ยืนยันรหัสผ่านไม่ถูกต้อง',
          icon: 'error',
          confirmButtonText: 'OK'
        }).then((res)=>{
          this.input.cPassword = ''
        })
        return
      }

      const self = this
      this.isProcess = true
      ManageAccountService.changePassword(this.data._id, this.input)
      .then((response)=>{
        console.log(response)
        if(response.success) {
          this.hideModal()
          this.$notify({
            type: 'success',
            title: 'สำเร็จ!',
            text: 'เปลี่ยนรหัสผ่านเสร็จเรียบร้อย',
          })
        }else{
          throw response
        }
      })
      .catch((e)=>{
        console.log(e)
        cAlert({
          ...e,
          title: 'ผิดพลาด!',
          text: e.message || 'เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.isProcess = false
      })
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('close')
    })
  }
}
</script>
